module.exports = __webpack_public_path__ + "img/02.7a3b9248.jpg";